var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThingsSupport = function SvgThingsSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DEE0",
    d: "M54.857 16v32L27.43 64 0 48V16L27.429 0zM5.273 19.076v25.848L27.43 57.848l22.155-12.924V19.076L27.429 6.152zm38.845 18.64c-9.03 9.03-23.672 9.03-32.702 0l3.771-3.772c6.948 6.948 18.212 6.948 25.16 0z"
  })));
};
export { SvgThingsSupport as ReactComponent };
export default __webpack_public_path__ + "fbfc68c0fa22dba179b307bdd19edde1.svg";